var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplashGym = function SvgSplashGym(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M22.821 11.893a1.607 1.607 0 0 1 3.214 0V24.75a1.607 1.607 0 0 1-3.214 0zM12.857 11.893a1.607 1.607 0 0 0-3.214 0V24.75a1.607 1.607 0 0 0 3.214 0zM26.036 14.464a1.607 1.607 0 0 1 3.214 0v7.714a1.607 1.607 0 0 1-3.214 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M9.643 14.464a1.607 1.607 0 0 0-3.214 0v7.714a1.607 1.607 0 0 0 3.214 0zM29.25 17.679a.964.964 0 1 1 1.929 0v1.285a.964.964 0 0 1-1.929 0zM6.429 17.679a.964.964 0 0 0-1.929 0v1.285a.964.964 0 1 0 1.929 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    strokeLinecap: "round",
    d: "M22.821 19.929v-3.215h-9.964v3.215h6.429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9B9A",
    d: "M23.693 22.23a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0"
  }))));
};
export default SvgSplashGym;